import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Modal from 'components/ui/modal';
import Form from 'components/form';
import Input from 'components/form/Input';
import Button from 'components/common/Button';
import Select from 'components/form/Select';
import { useQuery } from 'react-apollo';
import { GET_USERS } from 'graphql/admin/users';

const FormItem = Form.FormItem;

const styles = (theme) => ({
  root: {
    minWidth: 360,
  },
  input: {
    marginBottom: theme.spacing(3),
  },
});

const mapOptions = (response) =>
  response.data?.users.map((i) => ({
    value: i.user_id,
    label: `${i.user_first_name} ${i.user_last_name}`,
  }));

const EditGroup = ({
  onClose,
  onSubmit,
  group,
  form: { getFieldDecorator, validateFields },
  classes,
}) => {
  const lcData = useQuery(GET_USERS, {
    variables: { user_type: 'lead_coach', includeChildren: false },
  });

  const hcData = useQuery(GET_USERS, {
    variables: { user_type: 'head_coach', includeChildren: false },
  });

  const fcData = useQuery(GET_USERS, {
    variables: { user_type: 'fa_coach', includeChildren: false },
  });

  const handleSubmit = () => {
    return validateFields().then(onSubmit);
  };

  return (
    <Modal
      open
      title={'Edit Group'}
      onClose={onClose}
      actions={[
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>,
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          {'Save'}
        </Button>,
      ]}
    >
      <Form className={classes.root}>
        <FormItem>
          {getFieldDecorator('group_name', {
            initialValue: group.id ? group.name : '',
            rules: [{ required: true, message: 'Please enter group name' }],
          })(
            <Input
              fullWidth
              classes={{ root: classes.input }}
              margin="normal"
              variant="outlined"
              label="Group name"
            />,
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('lc_id', {
            initialValue: group?.lc_id ? group.lc_id : '',
            rules: [{ required: true }],
          })(
            <Select
              transformValue
              isMulti={false}
              loading={lcData.loading}
              label="CC"
              options={mapOptions(lcData)}
            />,
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('hc_id', {
            initialValue: group?.hc_id ? group.hc_id : '',
            rules: [{ required: true }],
          })(
            <Select
              transformValue
              isMulti={false}
              loading={hcData.loading}
              label="HC"
              options={mapOptions(hcData)}
            />,
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('fc_id', {
            initialValue: group?.fc_id ? group.fc_id : '',
            rules: [{ required: true }],
          })(
            <Select
              transformValue
              isMulti={false}
              loading={fcData.loading}
              label="FC"
              options={mapOptions(fcData)}
            />,
          )}
        </FormItem>
      </Form>
    </Modal>
  );
};

export default Form.create()(withStyles(styles)(EditGroup));
